const odataEndpoints = require('./odataEndpoints.json');

const state = {};
odataEndpoints.forEach((odata) => {
  state[odata.endPoint] = [];
  state[odata.name] = null;
});
export default state;
